import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import MTable, { MTableBodyRow } from 'material-table';
import { Paper, TablePagination } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const SavedCorpusTable = (props) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const {t}=useTranslation();

  if (! props.savedCorpora) {
    return "";
  }

  const onClickRow = (rowdata) => {
    setSelectedFile(rowdata.file);
    props.onSelectRow(rowdata);
  }

  const columnDefinition=[
    { title: t('name'), field: 'file' },
    { title: t('creationDate'), field: 'date' },
  ];

  const tableRows=props.savedCorpora.filter( 
    (corpus) => props.filter==="" || (corpus.file+corpus.keywords).match(props.filter) 
  );

  return (
    <div>
     
      <Paper>

        <MTable
            title={" "}
            columns={columnDefinition}
            data={tableRows}
            options={{
              filtering: true,
              search: true,
              sorting: true,
              exportButton: true,
              exportFile: 'personalCorpus',
              exportDelimiter:props.csvDelimiter,
              exportAlldata: true,
              pageSize:10,
              padding: 'dense',
              rowStyle: (rowData) => ({
                backgroundColor: ( selectedFile === rowData.file ) ? '#EEE' : '#FFF',
                height:'40px',
                maxHeight:'40px',
              })

            }}
            components={{
              Pagination: paginationProps => (
                <TablePagination
                  {...paginationProps}
                  rowsPerPageOptions={[ 10, 25, 50, 100, tableRows.length ]}
                />
              ),
              Container: containerProps => (
                <Paper
                  {...containerProps}
                  elevation={0}
                />
              ),
              Row: rowProps => (
                <MTableBodyRow
                  {...rowProps}
                  onRowClick = {(e,rowData) => onClickRow(rowData)}
                />
              )
            }}
        />


       {/*  <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ "fontWeight":"bold" }} align="left">{props.t('name')}</TableCell>
              <TableCell style={{ "fontWeight":"bold" }} align="right">{props.t('creationDate')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.savedCorpora.filter( (corpus) => 
              props.filter==="" || (corpus.file+corpus.keywords).match(props.filter) 
            ).map((corpus, idx) => (
              <TableRow
                key={corpus.file}
                onClick={() => onClickRow(idx)}
                selected={(selectedCorpusId === idx) ? true : false}
              >
                <TableCell align="left">{corpus.file}</TableCell>
                <TableCell align="right">{corpus.date}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table> */}
      </Paper>
    </div>
  );
};

SavedCorpusTable.propTypes = {
  savedCorpora: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.string,
      date: PropTypes.string,
    }),
  ),
  onSelectRow: PropTypes.func,
  filter:PropTypes.string,
  csvDelimiter:PropTypes.string,
};

export default withTranslation()(SavedCorpusTable);
